/** Valores em centavos (RealCurrencyInput / formatPrice) — sem conversão entre API e formulário. */
export function keepCents(value: unknown): number | undefined {
  if (value === null || value === undefined || value === "") return undefined;
  return Number(value);
}
